import React from "react";

export const initialData = {
    search: {
        startDate: null,
        endDate: null,
        namaSTNK: null,
        kodeCabang: null,
    },
    filter: {
        startDate: null,
        endDate: null,
        noFakturJual: null,
        noBuku: null,
        kodeVariant: null,
        kodeWarna: null,
        namaSTNK: null,
        namaPembeli: null,
        noKa: null,
        noSin: null
    }
}

export const tableColumns = {
    mainPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "tanggalFakturJual",
            label: "Tanggal Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorFakturJual",
            label: "Nomor Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorBuku",
            label: "No. Buku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val?.kodeVariant}</p>,
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (val) => <p>{val?.namaVariant}</p>,
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (val) => <p>{val?.kodeWarna}</p>,
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Nama Warna",
            options: {
                customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
                sort: false,
            },
        },
        {
            name: "namaSTNK",
            label: "Nama STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaPembeli",
            label: "Nama Pembeli",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
    ]
}